import * as kotlin from "./kotlin.js";
import * as swift from "./swift.js";
import * as go from "./go.js";
import * as csharp from "./csharp.js";
import * as java from "./java.js";
import * as objc from "./objc.js";
import * as python from "./python.js";
import * as ruby from "./ruby.js";
import * as rust from "./rust.js";


export default {
    kotlin,
    swift,
    go,
    csharp,
    java,
    objc,
    python,
    ruby,
    rust
}
